import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import {
    createEmployeeApi, employeeListApi,
    getEmployeeByIdApi, updateEmployeeApi,
    deleteEmployeeApi, deleteMessageEmployeeApi
} from "./EmployeeMasterApi";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";

const handleError = (err, rejectWithValue) => {
    if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    }
    const errorMessage = err.response?.data?.message ||
        err.response?.data?.data ||
        err.message ||

        "Something went wrong"

    showApiErrorToast(errorMessage);
    return rejectWithValue(err.response?.data || { message: err.message });
};

export const fetchEmployees = createAsyncThunk(
    "EmployeeMaster/fetch_employee",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await employeeListApi(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
)

export const createEmployee = createAsyncThunk(
    "EmployeeMaster/employee_master",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await createEmployeeApi(payload);
            showApiSuccessToast(response.data.message);
            return response;
        } catch (error) {
            return handleError(error, rejectWithValue)
        }
    }
)

export const getEmployeeById = createAsyncThunk(
    "employee/getById",
    async (EmployeeCode, { rejectWithValue }) => {
        try {
            return await getEmployeeByIdApi(EmployeeCode);
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message || err.message
            );
        }
    }
);

export const updateEmployee = createAsyncThunk(
    "employee/updateEmployee",
    async ({ EmployeeCode, payload }, { rejectWithValue }) => {
        try {
            const response = await updateEmployeeApi(EmployeeCode, payload);

            showApiSuccessToast(response.data.message);

            return response;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);

export const deleteMessageEmployee = createAsyncThunk(
  "employee/deleteMessage",
  async (EmployeeCode, { rejectWithValue }) => {
    try {
      return await deleteMessageEmployeeApi(EmployeeCode);
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "employee/delete",
  async (EmployeeCode, { rejectWithValue }) => {
    try {
      const response = await deleteEmployeeApi(EmployeeCode);

      showApiSuccessToast(response.message);

      return response;
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);